import url from '../url.js';
import axios from 'axios';
import {
  sendNewNodeMessage,
  sendNewEdgeMessage,
} from '../utils/socketTool';
// 定義每個群組對應的顏色 - 使用統一的紫色主題
const colorMap = {
  idea: { border: '#F3E8FF', background: '#F3E8FF' },         // 極淡紫色 - 想法
  information: { border: '#E0E7FF', background: '#E0E7FF' },  // 淡藍紫色 - 資訊
  question: { border: '#DDD6FE', background: '#DDD6FE' },     // 淡紫色 - 問題
  experiment: { border: '#FECACA', background: '#FECACA' },   // 淡紅色 - 實驗
  record: { border: '#C7D2FE', background: '#C7D2FE' },       // 中等藍紫色 - 記錄
  reply: { border: '#F9FAFB', background: '#F9FAFB' },        // 極淡灰色 - 回覆
  questionnaire: { border: '#D1FAE5', background: '#D1FAE5' }, // 淡綠色 - 問卷
  // 可以在此添加更多群組及其顏色
};

// 默認顏色
const defaultColor = { border: '#CCCCCC', background: '#EEEEEE' };

export const newNode = async (ideaData, activityId, ws) => {
  const isAnnouncement = ideaData.content.includes('【公告】'); // 判斷是否為公告
  
  // 獲取認證 token
  const jwtToken = localStorage.getItem('jwtToken');
  const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};

  return axios
    .post(`${url.backendHost}api/nodes/create`, ideaData, { 
      headers, 
      withCredentials: true 
    })
    .then((response) => {
      // 發送 WebSocket 消息
      sendNewNodeMessage(ws, {
        ...ideaData,
        id: response.data.node.id,
        createdAt: response.data.node.createdAt,
        updatedAt: response.data.node.updatedAt,
        activityId: activityId,
      });
      // 如果是公告，則發送公告專用事件
      if (isAnnouncement && ws) {
        ws.emit(`announcement-${ideaData.groupId}`, {
          ...ideaData,
          id: response.data.node.id,
          createdAt: response.data.node.createdAt,
        });
      }
      
      return response;
    })
    .catch((error) => {
      console.error('創建 node 失敗:', {
        error: error.message,
        response: error.response?.data,
        status: error.response?.status,
        nodeData: ideaData
      });
      throw error;
    });
};

export const newEdge = async (edgeData, activityId, ws) => {
  // 獲取認證 token
  const jwtToken = localStorage.getItem('jwtToken');
  const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};
  
  return axios
    .post(`${url.backendHost}api/edges/create`, edgeData, { 
      headers, 
      withCredentials: true 
    })
    .then((response) => {
      // 發送 WebSocket 消息
      sendNewEdgeMessage(ws, {
        ...edgeData,
        activityId: activityId,
      });
      return response;
    })
    .catch((error) => {
      console.error('創建 edge 失敗:', {
        error: error.message,
        response: error.response?.data,
        status: error.response?.status,
        edgeData: edgeData
      });
      throw error;
    });
};
function getEmoji(tag) {
  switch (tag) {
    case 'idea': {
      return '💡';
    }
    case 'information': {
      return '🔍';
    }
    case 'question': {
      return '❓';
    }
    case 'experiment': {
      return '🧪';
    }
    case 'record': {
      return '📄';
    }
    case 'reply': {
      return '💡';
    }
  }
}

const formatTimestamp = (timestamp) => {
  return new Intl.DateTimeFormat('en-US', {
    // year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    //   second: 'numeric',
    hour12: false,
  }).format(new Date(timestamp));
};

export const genEdge = (edgeData) => {
  // 
  return {
    from: edgeData.from,
    to: edgeData.to,
  };
};

export const genNode = (ideaData) => {
  const color = colorMap[ideaData.tags] || defaultColor;
  const isAnnouncement = ideaData.content.includes('【公告】'); // 判斷是否為公告
  const node = {
    id: String(ideaData.id), // 確保 ID 是字串
    label:
      getEmoji(ideaData.tags) +
      '\n\n' +
      ideaData.title +
      '\n\n' +
      ideaData.author +
      '\n' +
      `${formatTimestamp(ideaData.createdAt)}`,
    title: ideaData.content,
    group: ideaData.tags,
    color: color, // 添加 color 屬性
    borderWidth: 1, // 默認邊框寬度
    isAnnouncement,
  };

  //  // 調試用
  return node;
};

export const genNode_without_emoji = (ideaData) => {
  const color = colorMap[ideaData.tags] || defaultColor;
  const isAnnouncement = ideaData.content.includes('【公告】'); // 判斷是否為公告
  const node = {
    id: String(ideaData.id), // 確保 ID 是字串
    label:
      ideaData.title +
      '\n\n' +
      ideaData.author +
      '\n' +
      `${formatTimestamp(ideaData.createdAt)}`,
    title: ideaData.content,
    group: ideaData.tags,
    color: color, // 添加 color 屬性
    borderWidth: 1, // 默認邊框寬度
    isAnnouncement,
  };

  //  // 調試用
  return node;
};

// TODO: createMessage 端點尚未實現，此函數目前未使用
export const newMessage = async (messageData, ws) => {
  console.warn('newMessage: createMessage 配置不存在，此功能暫時不可用');
  return Promise.reject(new Error('createMessage 配置不存在'));
  // return axios
  //   .post(`${url.backendHost}api/messages/create`, messageData)
  //   .then((response) => {
  //     
  //     return response;
  //   });
};
